import HomeFieldConfig from 'app/views/home/webgl/particles/config/HomeFieldConfig';

/**
 * The GPU systems field set-point — THE place to tune (and, for Stage 2,
 * to CRANK) the shaders type's GPU systems department. Uniform with the CPU
 * departments' *Config files: one config module per tunable unit.
 *
 * The count is deliberately its OWN number, seeded from
 * HomeFieldConfig.systemsParticles (3650) so Stage 1 is a like-for-like
 * against the CPU systems pool — but DECOUPLED from HomeFieldConfig.total():
 * the GPU field owns its own ping-pong textures sized by `count`, not a slice
 * of the shared 11,021-lane ParticleCore (design §8.6). Raising `count` here
 * grows only the GPU field's own buffer — nothing else — which is the whole
 * point of the S1 scaling gate (sweep this past the CPU ceiling). 3650 was a
 * CPU limitation, not a design intent.
 */
export interface ShadersSystemsConfig {
	/** GPU systems particle count. Stage 1 = the shipped CPU count (3650);
	 *  Stage 2 sweeps it far higher. Its own buffer — see the module header. */
	count: number;
	/** Dot size in CSS px (scaled by renderer resolution at draw time). */
	pointSizePx: number;
	/** Field half-extents as fractions of innerWidth/innerHeight — how far the
	 *  seek dots spread from the systems zone centre. */
	fieldHalfWidthFactor: number;
	fieldHalfHeightFactor: number;
	/** Grid resolution the seek targets snap to (design/spike: 42 cells). */
	gridCells: number;
	/** Dot colour (systems greenBlues accent) as 0xRRGGBB. */
	colour: number;
}

export const shadersSystemsConfig: ShadersSystemsConfig = {
	//Stage-1 like-for-like with the CPU systems pool; the Stage-2/S1-GATE count
	//hook. Forwards HomeFieldConfig.systemsParticles LIVE so the /dev/home
	//?sysCount=N benchmark override raises the GPU field's own buffer in lockstep
	//with the CPU pool (a getter, not a captured value, so the sweep is honest):
	get count(): number {
		return HomeFieldConfig.systemsParticles;
	},
	pointSizePx: 1.6,
	fieldHalfWidthFactor: 0.46,
	fieldHalfHeightFactor: 0.42,
	gridCells: 42,
	colour: 0x3fd0c8
};
